export default "__VITE_ASSET__DzkIbQo___"